/* Notre Histoire : effets de la boutique (apparitions, compteurs, téléphones, pétales) */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function parseDate(s) {
    var m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
    return m ? new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), 0) : null;
  }

  /* ---- apparitions au défilement ---- */
  var revealIO = hasIO && !reduce ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function initReveal(scope) {
    var els = (scope || doc).querySelectorAll('[data-nh-reveal]:not(.is-in)');
    var vh = window.innerHeight || 800;
    els.forEach(function (el) {
      if (!revealIO) { el.classList.add('is-in'); return; }
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.95 && r.bottom > 0) el.classList.add('is-in'); else revealIO.observe(el);
    });
  }

  /* ---- compteurs « je t'aime depuis » ---- */
  var counters = [];
  function initCounters(scope) {
    (scope || doc).querySelectorAll('[data-nh-since]').forEach(function (el) {
      if (el._nh) return; el._nh = 1;
      var start = parseDate(el.getAttribute('data-nh-since')); if (!start) return;
      counters.push({ start: start, d: el.querySelector('[data-nh-d]'), h: el.querySelector('[data-nh-h]'), m: el.querySelector('[data-nh-m]'), s: el.querySelector('[data-nh-s]') });
    });
  }
  function tick() {
    var now = new Date();
    counters.forEach(function (c) {
      var diff = Math.max(0, now - c.start), days = Math.floor(diff / 864e5), rem = diff - days * 864e5;
      if (c.d) c.d.textContent = days.toLocaleString('fr-FR');
      if (c.h) c.h.textContent = pad(Math.floor(rem / 36e5));
      if (c.m) c.m.textContent = pad(Math.floor(rem % 36e5 / 6e4));
      if (c.s) c.s.textContent = pad(Math.floor(rem % 6e4 / 1e3));
    });
  }

  /* ---- téléphones qui défilent comme si quelqu'un lisait ---- */
  function initPhones(scope) {
    (scope || doc).querySelectorAll('[data-nh-phone]').forEach(function (ph) {
      if (ph._nh) return; ph._nh = 1;
      if (reduce) return;
      var page = ph.querySelector('[data-nh-page]'), screen = ph.querySelector('.nh-ph-screen');
      if (!page || !screen) return;
      var stops = [], i = 0, timer = 0, visible = false, hover = false;
      function measure() {
        var max = page.scrollHeight - screen.clientHeight, list = [0];
        page.querySelectorAll('.nh-ph-sec, .nh-ph-moment').forEach(function (s) {
          var y = Math.min(max, Math.max(0, s.offsetTop - screen.clientHeight * 0.06));
          if (y - list[list.length - 1] > screen.clientHeight * 0.35) list.push(y);
        });
        if (max - list[list.length - 1] > 10) list.push(max);
        stops = list;
      }
      function go() {
        clearTimeout(timer);
        if (!visible || hover || doc.hidden) return;
        if (!stops.length) measure();
        i = (i + 1) % stops.length;
        page.style.transitionDuration = i === 0 ? '2.4s' : '1.5s';
        page.style.transform = 'translateY(' + (-stops[i]) + 'px)';
        timer = setTimeout(go, i === 0 ? 4200 : (i === stops.length - 1 ? 3600 : 2600));
      }
      ph.addEventListener('mouseenter', function () { hover = true; clearTimeout(timer); });
      ph.addEventListener('mouseleave', function () { hover = false; timer = setTimeout(go, 1200); });
      window.addEventListener('resize', function () { stops = []; });
      if (hasIO) new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        clearTimeout(timer); if (visible) timer = setTimeout(go, 1800);
      }, { threshold: 0.35 }).observe(ph);
      else { visible = true; timer = setTimeout(go, 1800); }
    });
  }

  /* ---- pétales dans le héros ---- */
  function initPetals(scope) {
    (scope || doc).querySelectorAll('[data-nh-petals]').forEach(function (c) {
      if (c._nh || reduce || !c.getContext) return; c._nh = 1;
      var ctx = c.getContext('2d'), list = [], raf = 0, w = 0, h = 0, on = false;
      var cols = ['rgba(226,64,95,', 'rgba(233,211,160,', 'rgba(246,220,221,', 'rgba(194,30,58,'];
      function rf(a, b) { return a + Math.random() * (b - a); }
      function size() { var d = Math.min(window.devicePixelRatio || 1, 2); w = c.clientWidth; h = c.clientHeight; c.width = w * d; c.height = h * d; ctx.setTransform(d, 0, 0, d, 0, 0); }
      function make(top) { return { x: rf(0, w), y: top ? -20 : rf(0, h), s: rf(4, 9), v: rf(.25, .75), a: rf(0, 6.28), va: rf(-.015, .015), sw: rf(.3, 1), ph: rf(0, 6.28), c: cols[Math.floor(rf(0, cols.length))], o: rf(.25, .6) }; }
      function frame(t) {
        ctx.clearRect(0, 0, w, h);
        for (var i = 0; i < list.length; i++) {
          var p = list[i];
          p.y += p.v; p.a += p.va; p.x += Math.sin(t / 1600 + p.ph) * p.sw * .3;
          if (p.y > h + 20) list[i] = p = make(true);
          ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.fillStyle = p.c + p.o + ')';
          ctx.beginPath(); ctx.ellipse(0, 0, p.s, p.s * .55, 0, 0, Math.PI * 2); ctx.fill(); ctx.restore();
        }
        raf = requestAnimationFrame(frame);
      }
      function start() { if (on) return; on = true; raf = requestAnimationFrame(frame); }
      function stop() { on = false; cancelAnimationFrame(raf); }
      size(); var n = w < 700 ? 16 : 26; for (var i = 0; i < n; i++) list.push(make(false));
      window.addEventListener('resize', size);
      if (hasIO) new IntersectionObserver(function (es) { es[0].isIntersecting ? start() : stop(); }).observe(c); else start();
      doc.addEventListener('visibilitychange', function () { doc.hidden ? stop() : start(); });
    });
  }

  /* ---- menu mobile : signature, exemples et bouton ---- */
  var CDN = 'https://cdn.shopify.com/s/files/1/1069/9174/7414/files/photo-';
  function initDrawer() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    doc.querySelectorAll('.header-drawer .menu-drawer').forEach(function (d) {
      var nav = d.querySelector('.menu-drawer__navigation');
      if (!nav || d.querySelector('.nh-dr')) return;
      var brand = doc.createElement('p'); brand.className = 'nh-dr-brand';
      brand.innerHTML = 'Notre Histoire<span>Votre histoire, gravée sur un bijou.</span>';
      nav.parentNode.insertBefore(brand, nav);
      var box = doc.createElement('div'); box.className = 'nh-dr';
      box.innerHTML = '<a class="nh-dr-ex" href="' + base + 'pages/exemples"><span class="nh-dr-faces">' +
        ['1699726258869-36dff6247fd3', '1597906486268-fdb46a5120f2', '1615966650071-855b15f29ad1'].map(function (id) { return '<img src="' + CDN + id + '.jpg?width=96" alt="" width="38" height="38" loading="lazy">'; }).join('') +
        '</span><span><b>Voir les 8 exemples</b><small>De vrais sites, à ouvrir en entier</small></span></a>' +
        '<a class="nh-btn-gold" href="' + base + 'collections/all">Créer notre cadeau</a>' +
        '<p class="nh-dr-trust">Aperçu sous 24 à 48 h · Gravé seulement après votre accord</p>';
      nav.parentNode.insertBefore(box, nav.nextSibling);
    });
  }
  doc.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.header__icon--menu')) initDrawer(); }, true);

  function init(scope) { initReveal(scope); initCounters(scope); initPhones(scope); initPetals(scope); initDrawer(); tick(); }
  init();
  root.classList.add('nh-ready');
  setInterval(tick, 1000);
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
